import { DataTestIds } from '@repo/frontend-shared';
import { SDSText } from '@repo/sds/SDSText';

export function IntegrationsPage() {
  return <SDSText text=" Integrations" type="h1" dataTestId={DataTestIds.ADMIN.SIDEBAR.PAGE_TITLE} />;
}
